import { useState } from "react";
import { api } from "../api.js";
import { fmt, t } from "../i18n.js";
import { Empty, Loader, Pager, Tabs, useLoad } from "../ui.jsx";
import { TaskRow } from "./dashboard.jsx";
import { ObstacleDecision } from "./tasks.jsx";

export function Approvals() {
  const [tab, setTab] = useState("reviews");
  const [page, setPage] = useState(1);
  const reviews = useLoad(() => api.get(`/tasks?review_queue=1&sort=-updated&page=${page}&page_size=20`), [page]);
  const obstacles = useLoad(() => api.get("/obstacles?status=pending&page_size=50"), []);
  const [deciding, setDeciding] = useState(null);
  return (
    <div className="page">
      <header className="page-head"><h1>{t("approvals")}</h1></header>
      <Tabs value={tab} onChange={setTab} tabs={[["reviews", "مهام بانتظار المراجعة", reviews.data?.total || null],
        ["obstacles", "طلبات العوائق", obstacles.data?.total || null]]} />
      {tab === "reviews" && (
        <Loader state={reviews} isEmpty={(d) => !d.items.length} emptyView={<Empty title="لا توجد مهام بانتظار مراجعتك" />}>
          {(d) => <><div className="list">{d.items.map((x) => <TaskRow key={x.id} task={x}
            extra={` — ${x.assignee_name} — أُرسلت ${fmt.relative(x.last_submitted_at)}`} />)}</div>
            <Pager page={d.page} total={d.total} size={d.page_size} onPage={setPage} /></>}
        </Loader>
      )}
      {tab === "obstacles" && (
        <Loader state={obstacles} isEmpty={(d) => !d.items.length} emptyView={<Empty title="لا توجد طلبات عوائق مفتوحة" />}>
          {(d) => <div className="list">{d.items.map((o) => (
            <div className="row row-static" key={o.id}>
              <div className="row-main">
                <div className="row-title"><a href={`#/tasks/${o.task_id}`}><span className="ref">T-{o.task_number}</span>{o.task_title}</a></div>
                <div className="row-sub">{o.project_name} — {o.reporter_name} — {t("reason." + o.reason_code)} ({o.blocking === "full" ? "كلي" : "جزئي"})</div>
                <div className="row-sub">{o.description}</div>
                <div className="row-sub">حدث {fmt.dt(o.occurred_at)}</div>
              </div>
              <button className="btn btn-primary" onClick={() => setDeciding(o)}>اتخاذ قرار</button>
            </div>))}</div>}
        </Loader>
      )}
      {deciding && <ObstacleDecision o={deciding} mode="decide" onClose={() => setDeciding(null)} onDone={() => { setDeciding(null); obstacles.reload(); }} />}
    </div>
  );
}
